"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.YES_NO_ANSWERS = exports.VIRTUAL_CARE_ATTESTATION = exports.GX_CONTEXT_CONDITIONAL_KEYS = exports.GX_CONTEXT = exports.EHR_SUPPORTED_GX_QUESTIONS = void 0;
/**GX `context` is contextual information is sent to the GX backend API. */
const GX_CONTEXT = exports.GX_CONTEXT = {
  CLINICAL_KEYWORD: 'clinical_keyword',
  CURRENT_SECTION: {
    CONDITIONAL: 'conditional'
  }
};
/**All keys currently supported as GX Conditional contextual information by the GX backend API. */
const GX_CONTEXT_CONDITIONAL_KEYS = exports.GX_CONTEXT_CONDITIONAL_KEYS = ['current_section', 'visit_method'];

/**
 * Object with values for mapping a GX question to its EHR field.
 *     
 * - Adding an EHR field for a GX question:
 *     - Scheduling can receive arbitrary fields/params.
 *     - As long as the customer has the fields configured in `packed_appointment_fields`,
 *       Scheduling will add them to appointment notes in EHR.
 *     - @see https://kyruus.jira.com/wiki/spaces/AHC/pages/331677967/How+To+Sending+Registration+Data+in+Appointment+Notes
 
 * @typedef {Object} GXToEHRMapping
 * @property {string} name
 * @property {string} ehrField
 *
*/

/**
 * Map values for GX Telehealth Attestation and its EHR field
 * @type {GXToEHRMapping}
 */
const VIRTUAL_CARE_ATTESTATION = exports.VIRTUAL_CARE_ATTESTATION = {
  name: 'Virtual Care Attestation',
  ehrField: 'telehealth_attestation'
};

/** GX questions which currently have an EHR field. */
const EHR_SUPPORTED_GX_QUESTIONS = exports.EHR_SUPPORTED_GX_QUESTIONS = [VIRTUAL_CARE_ATTESTATION];
const YES_NO_ANSWERS = exports.YES_NO_ANSWERS = ['Yes', 'No'];